import { useMemo, useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { COUNTRIES } from "@/lib/countries";


export const CountryCombobox = ({ value, onChange, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const selectedCountry = useMemo(() => COUNTRIES.find((country) => country === value) || "", [value]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          disabled={disabled}
          className="h-10 w-full justify-between rounded-md border border-input bg-transparent px-3 text-left text-sm font-normal text-slate-900 hover:bg-transparent"
          data-testid="apply-country-combobox-trigger"
        >
          <span className={cn("truncate", !selectedCountry && "text-slate-500")}>{selectedCountry || "Select country"}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] min-w-[16rem] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search country..." data-testid="apply-country-search-input" />
          <CommandList>
            <CommandEmpty data-testid="apply-country-empty-state">No country found.</CommandEmpty>
            {COUNTRIES.map((country) => {
              const optionSlug = country.toLowerCase().replace(/[^a-z0-9]+/g, "-");
              return (
                <CommandItem
                  key={country}
                  value={country}
                  onSelect={(currentValue) => {
                    onChange(currentValue);
                    setOpen(false);
                  }}
                  data-testid={`apply-country-option-${optionSlug}`}
                >
                  <Check className={cn("mr-2 h-4 w-4", selectedCountry === country ? "opacity-100" : "opacity-0")} />
                  {country}
                </CommandItem>
              );
            })}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};